// @flow

import * as React from 'react';
import { Popover } from 'antd';

type Props = {
  contact: any,
  children: React.Node,
}

const ContactInfoPopover = ({ contact, children }: Props) => {
  if (!contact) {
    return children;
  }

  const content = (
    <div style={{ minWidth: 150 }}>
      <div>
        <strong>Tel: </strong>
        {contact.telephone || '--'}
      </div>
      <div>
        <strong>Email: </strong>
        {contact.email || '--'}
      </div>
    </div>
  );

  return (
    <Popover trigger="hover" content={content}>
      <div>{children}</div>
    </Popover>
  );
};

export default ContactInfoPopover;
